import React from "react";

/** Returns a strength score 0..4 + label/color. */
function score(pw) {
    if (!pw) return { s: 0, label: "" };
    let s = 0;
    if (pw.length >= 8) s += 1;
    if (pw.length >= 12) s += 1;
    if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s += 1;
    if (/\d/.test(pw)) s += 1;
    if (/[^A-Za-z0-9]/.test(pw)) s += 1;
    s = Math.min(s, 4);
    const label = ["Too short", "Weak", "Okay", "Strong", "Excellent"][s];
    return { s, label };
}

const COLORS = ["bg-accent-red", "bg-accent-red", "bg-accent-amber", "bg-accent-cyan", "bg-accent-mint"];
const LABEL_COLORS = ["text-accent-red", "text-accent-red", "text-accent-amber", "text-accent-cyan", "text-accent-mint"];

export const PasswordStrengthMeter = ({ password = "" }) => {
    const { s, label } = score(password);
    return (
        <div className="mt-2" data-testid="password-strength">
            <div className="flex gap-1">
                {[0, 1, 2, 3, 4].map((i) => (
                    <span
                        key={i}
                        className={`h-1 flex-1 rounded-full transition-colors duration-200 ${
                            i < s ? COLORS[s] : "bg-white/[0.06]"
                        }`}
                    />
                ))}
            </div>
            {password && (
                <p
                    className={`mt-1.5 text-[11px] font-mono uppercase tracking-[0.18em] ${LABEL_COLORS[s]}`}
                    data-testid="password-strength-label"
                >
                    {label}
                </p>
            )}
        </div>
    );
};

export default PasswordStrengthMeter;
